interface BackArrowBlueProps {
  className?: string;
  height?: number;
  width?: number;
  stroke?: string;
  strokeWidth?: number;
  onClick?: () => void;
}
const BackArrowBlue = (props: BackArrowBlueProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? 16}
      height={props.height ?? 16}
      viewBox="0 0 16 16"
      fill="none"
      className={props.className}
      onClick={props.onClick}
    >
      <path
        d="M7.4513 12.9839L2.81797 8.35052C2.76241 8.29497 2.72352 8.23941 2.7013 8.18385C2.67908 8.1283 2.66797 8.06719 2.66797 8.00052C2.66797 7.93385 2.67908 7.87274 2.7013 7.81719C2.72352 7.76163 2.76241 7.70608 2.81797 7.65052L7.46797 3.00052C7.55686 2.91163 7.66797 2.86719 7.8013 2.86719C7.93464 2.86719 8.0513 2.91719 8.1513 3.01719C8.2513 3.11719 8.3013 3.23385 8.3013 3.36719C8.3013 3.50052 8.2513 3.61719 8.1513 3.71719L4.36797 7.50052H12.6346C12.7791 7.50052 12.8985 7.54774 12.993 7.64219C13.0874 7.73663 13.1346 7.85608 13.1346 8.00052C13.1346 8.14497 13.0874 8.26441 12.993 8.35885C12.8985 8.4533 12.7791 8.50052 12.6346 8.50052H4.36797L8.16797 12.3005C8.25686 12.3894 8.3013 12.5005 8.3013 12.6339C8.3013 12.7672 8.2513 12.8839 8.1513 12.9839C8.0513 13.0839 7.93464 13.1339 7.8013 13.1339C7.66797 13.1339 7.5513 13.0839 7.4513 12.9839Z"
        fill={props.stroke ?? "#0056D6"}
      />
    </svg>
  );
};

export default BackArrowBlue;
